module.exports = __webpack_public_path__ + "static/media/th.7b76b287.svg";